import { render, staticRenderFns } from "./QueryStockBrigade.vue?vue&type=template&id=237fa322&"
import script from "./QueryStockBrigade.vue?vue&type=script&lang=js&"
export * from "./QueryStockBrigade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports